<template>
  <section class="o-fairListing" :class="{ 'c-purple': purple }">
    <div class="o-container o-container--xlarge">
      <h2 class="u-centered">{{ title }}</h2>
      <div class="o-fairListing__list" v-if="Object.keys(list).length > 0">
        <card-fair-series
          v-for="fairSeries in this.list.slice(0, fairsToShow)"
          :title="fairSeries.title"
          :code="fairSeries.code"
          :fairCode="fairSeries.fairCode"
        />
      </div>
      <div
        class="u-centered"
        v-if="list.length > 3 && !fairsToShow !== Infinity"
      >
        <bos-button ghost :color="purple ? 'white2' : ''" @click="showAll">{{
          $t('components.fairListing.active.showAll')
        }}</bos-button>
      </div>
      <div class="u-centered" v-if="list.length === 0">
        {{ $t('components.fairListing.active.notAvailable') }}
      </div>
    </div>
  </section>
</template>

<script>
import { getLocalizationInExcludes, localize } from '@/assets/js/helper'
import CardFairSeries from './CardFairSeries'
import BosButton from './BosButton'
import CardAction from './CardAction'
import ApiService from '../services/ApiService'

export default {
  name: 'BosPastFairListi',
  components: { CardAction, BosButton, CardFairSeries },
  props: {
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    },
    purple: Boolean
  },
  data() {
    return {
      selectedFair: null,
      fairsToShow: 3
    }
  },
  computed: {},
  methods: {
    showAll() {
      this.fairsToShow = Infinity
    }
  },
  created() {
    console.log(this.list)
  }
}
</script>

<style lang="scss" scoped>
.o-fairListing {
  background-color: transparent;
  padding: 4.5rem 0;

  .o-fairListing__list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 2.25rem;

    > div {
      margin: 2.25rem;
    }

    @media (max-width: 720px) {
      justify-content: center;
    }
  }

  &.c-purple {
    background-color: #635971;
    color: #f7f6f3;
  }
}
</style>
